export default "__VITE_ASSET__D$RxKFj$__"